import {Injectable} from '@angular/core';
import {NeoRestService} from "../neo-rest/neo-rest.service";

@Injectable()
export class NeoAvailService {

    constructor(
       private _rest: NeoRestService
    ) {}

    /**
     * Devuelve el listado de disponibilidades
     *
     * @return Un objeto observable
     * */
    searchAvailabilities(availabilitiesOptions) {
        return this._rest.postRaw('/availability', availabilitiesOptions);
    }

    /**
     * Obtiene las disponibilidades de los extras
     *
     * @param availabilitiesOptions
     * @returns {Observable<any>}
     */
    getExtraAvailabilities(availabilitiesOptions) {
        return this._rest.postRaw(`/availability/extras`, availabilitiesOptions);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-avail/neo-avail.service.ts